import { type ReactNode } from 'react';
import { Paragraph } from '@hungryroot/ramen';

import styles from './PricingNudge.module.css';

type Props = {
  icon?: ReactNode;
  children: ReactNode;
};

export function PricingNudge({ icon, children }: Props) {
  return (
    <Paragraph variant="caption" className={styles.container}>
      {icon}
      {children}
    </Paragraph>
  );
}
